import moment from 'moment'

class SingleServiceTime {
  private static instance: SingleServiceTime | null = null
  clientServerDateDiff: number

  constructor() {
    this.clientServerDateDiff = 0
  }

  static getInstance() {
    if (!SingleServiceTime.instance) {
      SingleServiceTime.instance = new SingleServiceTime()
    }
    return SingleServiceTime.instance
  }

  getServerTime(type: 'moment'): moment.Moment
  getServerTime(type: 'timestamp'): number
  getServerTime(type: 'moment' | 'timestamp'): moment.Moment | number {
    if (type === 'moment') {
      return moment(Date.now() + this.clientServerDateDiff)
    }

    return Date.now() + this.clientServerDateDiff
  }

  get serviceDate() {
    return moment(Date.now() + this.clientServerDateDiff)
  }
}

const serverTimeUtil = SingleServiceTime.getInstance()

export default serverTimeUtil
